<template>
  <div>
    <ForgotPasswordModal></ForgotPasswordModal>

    <div class="modal fade show" id="login-medhub" role="dialog" style="display:block;" v-if="open">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" data-dismiss="modal" aria-label="Close" class="close" @click="closeModal()">
              <span aria-hidden="true">
                <i class="fa-sharp fa-regular fa-xmark"></i>
              </span>
            </button>
            <h2 class="mb-4 text-center">Login to the Sage Medical Hub</h2>

            <!-- TODO-START: style error container -->

            <div class="alert-content red" v-if="error">
              <div class="alert-description text-center text-sm text-red-600 mt-5">
                {{ error.message }}
              </div>
            </div>
            <!-- TODO-END:-->

            <form @submit="next">
              <div class="form-group text-left">
                <label for="login-email">Email*</label>
                <input type="email"
                       required
                       class="form-control mb-3"
                       placeholder="Enter your e-mail..."
                       v-model="form.email"
                />
                <label for="login-password">Password*</label>
                <input type="password"
                       class="form-control mb-3"
                       placeholder="Enter your password..."
                       v-model="form.password"
                />
              </div>

              <div class="forgot-password text-right mb-4">
                <a @click="showForgotPw"
                   href="#">
                  <!-- TODO: Toggle cursor -->Forgot password?
                </a>
              </div>
              <div class="text-center">
                <button
                    class="btn btn-primary"
                    type="submit"
                    :disabled="progress || formErrors.length>0"
                    @click="next">
                  <!-- TODO: Add back progress indicator -->
                  <!--                {{ !progress ? 'Sign In' : '' }}-->Sign In
                </button>
              </div>
            </form>
            <div class="hr-div py-3">
              <hr/>
            </div>
            <p class="text-center">Don’t have an account?
              <a href="#" @click="showSignup">
                Create an account
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-backdrop fade show" v-if="open"></div>
  </div>
</template>
<script>
import Validator from '../../helpers/validation';
import {Auth} from 'aws-amplify';
import ForgotPasswordModal from '@/components/auth/ForgotPasswordModal.vue';

export default {
  name: 'LoginModal',
  components: {
    ForgotPasswordModal
  },
  data: function () {
    return {
      error: null,
      progress: false,
      form: {
        email: '',
        password: ''
      }
    };
  },
  computed: {
    open: function () {
      return this.$store.state.modals.showLoginModal;
    },
    formErrors: function () {
      return Validator.validateLogin(this.form);
    }
  },
  methods: {
    showForgotPw: function () {
      console.log('showForgotPw');
      this.$store.dispatch('modals/setShowForgotPasswordModal', true);
      this.closeModal();
    },
    showSignup: function () {
      console.log('showSignup');
      this.$store.dispatch('workflow/setCurrentStep', 'signup');
      this.$store.dispatch('modals/setShowSignupModal', true);
      this.closeModal();
    },
    closeModal: function () {
      console.log('closeModal');
      this.$store.dispatch('modals/setShowLoginModal', false);
      this.form = {};

      try {
        window.dataLayer.push({
          'event': 'interstitial',
          'click_text': 'CLOSE',
          'interstitial_name': 'Interstitial Sign In'

        });
      } catch (e) {
        console.warn('write to DataLayer error')
      }

    },
    next: async function (e) {
      e.preventDefault();

      let errors = Validator.validateLogin(this.form);
      if (errors.length > 0) {
        console.log('ERRORS', errors);
        return;
      }

      this.error = null;
      this.progress = true;

      try {
        await Auth.signIn(this.form.email, this.form.password);
        // set form data into workflow store
        this.form = {};

        // close modal
        this.$store.dispatch('modals/setShowLoginModal', false);

        try {
          window.dataLayer.push({
            'event': 'interstitial',
            'click_text': 'SIGN IN',
            'interstitial_name': 'Interstitial Sign In'

          });
        } catch (e) {
          console.warn('write to DataLayer error')
        }

        console.log('login success');

        this.progress = false;
        window.location.reload();
        // this.$router.replace('/');
      } catch (e) {
        console.log('error', e);
        this.error = {
          message: e.message ? e.message : 'Unable to login',
          code: 14
        };

        this.progress = false;
      }


    }
  },
  mounted() {
    // TODO: Remove
    //  setTimeout(() => {
    //    this.$store.dispatch('modals/setShowPasswordModal', true);
    //  }, 1000);
  }
};
</script>
<style scoped>

</style>
